import { render } from "./PhaseDeterminationDetail.vue?vue&type=template&id=47b1d387&scoped=true"
import script from "./PhaseDeterminationDetail.vue?vue&type=script&lang=js"
export * from "./PhaseDeterminationDetail.vue?vue&type=script&lang=js"

import "./PhaseDeterminationDetail.vue?vue&type=style&index=0&id=47b1d387&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b1d387"]])

export default __exports__